import Fuse from 'fuse.js';

const getFuse = (items, options) => new Fuse(items, options);

export default getFuse;
